import { runClientComponent } from '../../_common/client/client-component-runner';
import { UpsellingComponent } from './upselling.component';

runClientComponent({ UpsellingComponent: UpsellingComponent });
